import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer d-flex flex-column flex-md-row justify-content-between align-items-center p-4 px-5">
            <div className="footer-links d-flex flex-column flex-md-row">
                <Link to="/home" className="footer-link">Trang chủ</Link>
                <Link to="/knowledge" className="footer-link">Kiến thức</Link>
                <Link to="/products" className="footer-link">Sản phẩm</Link>
                <Link to="/contact" className="footer-link">Liên hệ</Link>
            </div>
            <div className="footer-copyright text-center mt-3 mt-md-0">
                Copyright by An Classical 2024
            </div>
        </footer>
    );
};

export default Footer;